import { render, staticRenderFns } from "./c-year-list@.vue?vue&type=template&id=7869fb0d&"
import script from "./c-year-list@.vue?vue&type=script&lang=ts&"
export * from "./c-year-list@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports